import axios from 'axios';
import Cookies from 'js-cookie';

const loginServerClientID = process.env.LOGIN_SERVER_CLIENT_ID;
const loginServerRefreshURL = process.env.TOKEN_REFRESH_URL;
const cookieDomain = process.env.JWT_COOKIE_DOMAIN_NAME || 'localhost';
const secureCookies = process.env.SECURE_JWT_COOKIES === 'true';
const cookieName = process.env.ACCESS_TOKENS_COOKIE_NAME;

async function callToRefreshToken(error) {
  return axios
    .post(
      loginServerRefreshURL,
      {
        client_id:     JSON.parse(atob(Cookies.get(cookieName))).client_id || loginServerClientID,
        grant_type:    'refresh_token',
        refresh_token: JSON.parse(atob(Cookies.get(cookieName))).refresh_token,
      },
    )
    .then((response) => {
      if (response && response.status === 200) {
        const unencoded = atob(Cookies.get(cookieName));
        const parsed = JSON.parse(unencoded);
        const newAccessToken = response.data.access_token;
        const newRefreshToken = response.data.refresh_token;
        const newAccessTokens = {
          ...parsed,
          access_token:  newAccessToken,
          refresh_token: newRefreshToken,
        };
        const encoded = btoa(JSON.stringify(newAccessTokens));
        Cookies.set(cookieName, encoded, { secure: secureCookies, domain: cookieDomain });
        // Token refreshed, try request again
        const requestConfig = { ...error.config };
        requestConfig.headers.Authorization = `Bearer ${newAccessToken}`;
        return axios(requestConfig);
      }
      window.axiosActive -= 1;
      return Promise.reject(error);
    })
    .catch((retryError) => {
      if (retryError.response?.status === 401) {
        Cookies.remove(cookieName, { secure: secureCookies, domain: cookieDomain });
        window.axiosActive -= 1;
        return Promise.reject(retryError);
      }
      window.axiosActive -= 1;
      return Promise.reject(error);
    });
}

export default callToRefreshToken;
